module.exports = __webpack_public_path__ + "assets/bag_not_available_icon.png";